import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Activity } from "lucide-react";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { googleLogin } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = location.hash || window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login");
      return;
    }
    const sessionId = decodeURIComponent(match[1]);
    (async () => {
      try {
        const u = await googleLogin(sessionId);
        window.history.replaceState(null, "", "/dashboard");
        if (!u?.profile?.onboarded) navigate("/onboarding", { replace: true });
        else navigate("/dashboard", { replace: true });
      } catch {
        navigate("/login", { replace: true });
      }
    })();
  }, [location.hash, googleLogin, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#F8FAFC]">
      <Activity className="h-8 w-8 animate-pulse text-[#18A6A6]" />
    </div>
  );
}
